import { Link } from "react-router";
export default function NotFound() {
  return (
    <div style={{ textAlign: "center", padding: "2rem", color: "white" }}>
      <img src="/3.webp" alt="Amumu sad" style={{ width: "164px" }} />
      <h2>404 - Page Not Found</h2>
      <p style={{marginBottom: "40px"}}>The page you’re looking for doesn’t exist.</p>
      <Link to="/" style={{ padding: "6px 16px", color: "white", textDecoration: "none", backgroundColor: "#3273FA", borderRadius: "90px", fontWeight: "700" }}>
        Return
      </Link>
    </div>
  );
}
